import React from 'react';
import PropTypes from 'prop-types';
import { LuArrowRight, LuBookOpen, LuCalendarDays, LuListTodo, LuPartyPopper, LuShieldCheck, LuUserRound } from 'react-icons/lu';
import Modal from '../../components/ui/Modal';
import Button from '../../components/ui/Button';
import GlassIcon from '../../components/ui/GlassIcon';
import { useTranslation } from '../../i18n/LanguageContext';

const STEPS = [
  { key: 'profile', icon: LuUserRound, gradient: 'tw-from-teal-400 tw-to-cyan-500 tw-shadow-teal-500/30' },
  { key: 'tasks', icon: LuListTodo, gradient: 'tw-from-blue-500 tw-to-indigo-500 tw-shadow-blue-500/30' },
  { key: 'calendar', icon: LuCalendarDays, gradient: 'tw-from-violet-500 tw-to-fuchsia-500 tw-shadow-violet-500/30' },
  { key: 'security', icon: LuShieldCheck, gradient: 'tw-from-amber-400 tw-to-orange-500 tw-shadow-amber-500/30' },
];

/**
 * Sisteme ilk kez giriş yapan çalışanlara gösterilen karşılama penceresi.
 * Yalnızca bir kez gösterilir; gösterim kararı Dashboard tarafından verilir.
 */
const WelcomeModal = ({ isOpen, userName, onClose, onOpenManual }) => {
  const { t, language } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      lang={language}
      title={userName ? t('welcome.greeting', { name: userName }) : t('welcome.greetingNoName')}
      subtitle={t('welcome.badge')}
      icon={(
        <GlassIcon gradient="tw-from-teal-400 tw-to-violet-500 tw-shadow-teal-500/30">
          <LuPartyPopper aria-hidden="true" className="tw-h-6 tw-w-6" />
        </GlassIcon>
      )}
      closeLabel={t('common.close')}
      footer={(
        <>
          <Button onClick={onOpenManual}>
            <LuBookOpen aria-hidden="true" className="tw-h-4 tw-w-4" />
            {t('welcome.manual')}
          </Button>
          <Button variant="primary" onClick={onClose}>
            {t('welcome.start')}
            <LuArrowRight aria-hidden="true" className="tw-h-4 tw-w-4" />
          </Button>
        </>
      )}
    >
      <p className="tw-text-sm tw-leading-relaxed tw-text-slate-600 sm:tw-text-[15px] dark:tw-text-slate-300">
        {t('welcome.intro')}
      </p>

      <ul className="tw-mt-5 tw-grid tw-gap-3 sm:tw-grid-cols-2">
        {STEPS.map(({ key, icon: Icon, gradient }) => (
          <li
            key={key}
            className="tw-flex tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-200/80 tw-bg-slate-50 tw-p-4 dark:tw-border-white/10 dark:tw-bg-white/[0.04]"
          >
            <GlassIcon gradient={gradient} size="xs">
              <Icon aria-hidden="true" className="tw-h-[18px] tw-w-[18px]" />
            </GlassIcon>
            <div className="tw-min-w-0">
              <h3 className="tw-text-sm tw-font-semibold tw-text-slate-900 dark:tw-text-white">{t(`welcome.steps.${key}.title`)}</h3>
              <p className="tw-mt-1 tw-text-xs tw-leading-relaxed tw-text-slate-600 dark:tw-text-slate-400">{t(`welcome.steps.${key}.description`)}</p>
            </div>
          </li>
        ))}
      </ul>

      <p className="tw-mt-5 tw-text-xs tw-leading-relaxed tw-text-slate-500 dark:tw-text-slate-400">{t('welcome.footer')}</p>
    </Modal>
  );
};

WelcomeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  userName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onOpenManual: PropTypes.func.isRequired,
};

export default WelcomeModal;
